<section class="tw-flex tw-flex-col tw-justify-between tw-py-6 tw-px-4" [ngClass]="title ? '' : 'tw-min-h-[200px]'">
  <section *ngIf="title; else simpleTextTemplate" class="tw-flex tw-flex-col tw-items-start tw-mb-6 tw-px-2">
    <p class="tw-text-main-text tw-text-lg tw-font-semibold tw-mb-2">{{title}}</p>
    <p class="tw-text-main-text tw-text-sm">{{text}}</p>
    <p *ngIf="note" class="tw-text-gray-500 tw-text-xs tw-mt-3 tw-mb-0">{{note}}</p>
  </section>

  <ng-template #simpleTextTemplate>
    <section class="tw-flex tw-justify-center tw-items-start tw-mb-6">
      <p class="tw-text-main-text tw-text-xl tw-font-[Rubik] tw-text-center">{{text}}</p>
    </section>
  </ng-template>

  <section class="tw-flex {{ title ? 'tw-justify-end tw-pt-4 tw-border-t tw-border-[#E8E8E8]' : 'tw-justify-center' }} tw-items-end {{ isMobile ? 'tw-gap-2' : 'tw-gap-5'}}">
    <mh-core-lib-button
        [isSecondary]="true"
        [text]="(data.cancelText || 'commons.cancel') | translate"
        [width]="isMobile ? 120 : 160"
        (clicked)="handleButtonClick('CANCEL')"
        ></mh-core-lib-button>
    <mh-core-lib-button
        [isPrimary]="true"
        [text]="(data.acceptText || 'commons.accept') | translate"
        [width]="isMobile ? 120 : 160"
        [customClass]="title ? '!tw-px-3 tw-whitespace-nowrap' : ''"
        (clicked)="handleButtonClick('ACCEPT')"
        ></mh-core-lib-button>
  </section>
</section>
